/**
 *
 * Asynchronously loads the component for 
 * Author: LanVt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
